import React, { SVGProps } from 'react';

export const IconRadioDot = (props: SVGProps<SVGSVGElement>) => <svg fill="none" viewBox="0 0 32 32" width="1em" height="1em" {...props}><circle cx="16" cy="16" r="10" fill="currentColor"/></svg>;
